import { indexTopics } from "@/mocks/homeData";

export default function IndexSection() {
  return (
    <section id="index" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            剧集分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按类型探索海量电视剧资源，快速找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexTopics.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex flex-col items-center gap-2 bg-background-50 rounded-lg border border-background-200/60 p-4 md:p-5 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl`} />
              </div>
              <h3 className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {item.count.toLocaleString()} 部
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}